<ng-container *ngrxLet="vm$ as vm">
  @if (vm.isZendeskEnabled) {
    <mp-zendesk-help-center-button
      [isSmall]="isSmall()"
      (openZendeskHelpCenterInfoFlyoutClick)="
        onOpenZendeskHelpCenterInfoFlyoutClick(); trackHelpCenterButtonClick('zendesk')
      "
    />
  } @else {
    <mp-help-center-direct-link-button
      [helpCenterLink]="vm.helpCenterSettings.directLink || ''"
      [isSmall]="isSmall()"
      (click)="trackHelpCenterButtonClick('direct-link')"
    />
  }

  <ng-template #createTicketButtonTemplate>
    <mp-zendesk-support-dialog-container #zendeskSupportDialogContainerComponent>
      <mp-create-ticket-button
        (createTicketButtonClick)="zendeskSupportDialogContainerComponent.openZendeskSupportDialog()"
      />
    </mp-zendesk-support-dialog-container>
  </ng-template>
</ng-container>
